import { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { useCatalogContext } from "../../contexts/CatalogContextProvider";
import { colorsConfig } from "../../config/colorsConfig";
import { isoTimestampToReadable } from "../utils/timeStampConversion.js";

const OrderDetails = () => {
  const { apiCallOrderDetails } = useCatalogContext();

  const [ordersData, setOrderData] = useState([]);

  const orderTableColumns = [
    {
      name: "Order Date",
      selector: (row) => {
        return <span>{isoTimestampToReadable(row?.timestamp)}</span>;
      },
      sortable: true,
      width: "200px",
      wrap: true,
    },
    {
      name: "Order Amount",
      selector: (row) => row?.orderAmount,
      sortable: true,
      width: "150px",
      wrap: true,
    },
    {
      name: "Order ID",
      selector: (row) => row?.orderId,
      sortable: true,
      width: "300px",
    },
    {
      name: "Item Description",
      selector: (row) => (
        <pre className="whitespace-break-spaces text-sm">
          {row?.description}
        </pre>
      ),
      width: "400px",
      wrap: true,
    },
    {
      name: "Order From",
      selector: (row) => row?.userPhoneNo,
      sortable: true,
      width: "150px",
      wrap: true,
    },
    {
      name: "Currency",
      selector: (row) => row?.paymentDetails?.currency,
      sortable: true,
      width: "150px",
    },
    {
      name: "Payment Status",
      selector: (row) => row?.paymentStatus,
      sortable: true,
      width: "150px",
    },
    {
      name: "Payment Date",
      selector: (row) =>
        row?.paymentTimeStamp && isoTimestampToReadable(row?.paymentTimeStamp),
      sortable: true,
      width: "200px",
    },
    {
      name: "Payment Method",
      selector: (row) => row?.paymentDetails?.paymentMethod,
      sortable: true,
      width: "200px",
    },
    {
      name: "Payment ID",
      selector: (row) => row?.paymentDetails?.paymentId,
      width: "250px",
    },
    {
      name: "Payment Gateway",
      selector: (row) => row?.paymentGateway,
      sortable: true,
      width: "200px",
    },
  ];

  const fetchOrderDetails = async () => {
    const response = await apiCallOrderDetails();
    setOrderData(response);
  };

  useEffect(() => {
    fetchOrderDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="w-full mt-5 mb-10 lg:my-1 space-y-5">
      <div className="w-full space-y-2">
        <h1 className="text-2xl">Meta Commerce Order Details</h1>
        <h3>
          View all Meta commerce order details that we have received on
          WhatsApp.
        </h3>
      </div>
      <div className="my-5 space-y-2 rounded-md">
        <DataTable
          columns={orderTableColumns}
          data={ordersData}
          customStyles={orderDetailsTableStyle}
          fixedHeader
          fixedHeaderScrollHeight="60vh"
        />
      </div>
    </main>
  );
};
export default OrderDetails;

const orderDetailsTableStyle = {
  rows: {
    style: {},
  },
  headCells: {
    style: {
      backgroundColor: colorsConfig.mediumGrey,
      color: "#FFFFFF",
      fontSize: "0.9rem",
    },
  },
  cells: {
    style: {},
  },
};
